import { SharePreviewProps } from 'components/ShareDocument/SharePreviewContent/sharePreviewHelpers';

const ImagePreview = ({ url, filename }: SharePreviewProps) => (
  <img src={url} alt={filename} className='attachment-preview-image' />
);

export default ImagePreview;
